import { Inject, Injectable, InjectionToken, LOCALE_ID } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';

import { DataAccessScreensizeFacade } from '@planone/bau365/data-access-screensize';
import { Observable } from 'rxjs';

export const SHARE_BUTTON_CONFIG = new InjectionToken<string>('SHARE_BUTTON_CONFIG');

@Injectable()
export class ShareButtonsHelper {
  size$: Observable<string | undefined>;

  constructor(
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(SHARE_BUTTON_CONFIG) private host: string,
    private screenSizeFacade: DataAccessScreensizeFacade,
    private bottomSheet: MatBottomSheet,
    public dialog: MatDialog
  ) {
    this.size$ = screenSizeFacade.size$;
  }

  buildShareUrlFromPath(path: string) {
    const locale = this.localeId.split('-');

    return this.host + '/' + (locale[0] ?? 'de') + '/' + path;
  }
}
